<template>
   <div>
        <div class="border border-yellow-500 rounded-2xl p-4 mt-7">
            <h3 class="relative text-yellow-500 bg-pink-900 rounded-3xl w-28 text-center font-bold text-xs uppercase -mt-7 mx-auto block py-[6px]">
                <slot></slot>
            </h3>
            
            <div class="flex">
                <GoalGauge v-for="(goal, index) in goals" :key="index" :goal="goal.target" :progress="goal.progress" :percentage="goal.percentage" class="w-1/2">
                    {{ goal.name }}
                </GoalGauge>
            </div>
        </div>
   </div>
</template>

<script>
import GoalGauge from '@/Components/GoalGauge.vue'

export default {
    components: {
        GoalGauge
    },
    props: {
        goals:{
            type: Array,
            default: []
        }
    }
}
</script>
